export const sizeTypes = {
  '1M+': '1M +',
  '500K-1M': '500K-1M',
  '250K-500K': '250K-500K',
  '100K-250K': '100K-250K',
  '0-100K': '0-100K',
};
